import { CustomTalkingPoint as CustomTalkingPointNode } from "@acto/gql/graphql";
import dayjs, { Dayjs } from "dayjs";

export default class CustomTalkingPoint {
  constructor(
    public readonly id: string,
    public readonly clientId: string,
    public readonly title: string,
    public readonly userDetailsId: number,
    public readonly createdAt: Dayjs,
    public readonly completedAt: Dayjs | null,
  ) {}

  static fromGraphql(data: CustomTalkingPointNode): CustomTalkingPoint {
    return new CustomTalkingPoint(
      data.id,
      data.client.id,
      data.title,
      data.userDetailsId,
      dayjs(data.createdAt),
      data.completedAt ? dayjs(data.completedAt) : null,
    );
  }
}
